var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{ref:"table",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.itemsPerPage,"pageCount":_vm.pageCount,"changePage":_vm.changePage,"isLoad":_vm.isLoad,"noDataText":_vm.$t('NoAvailableData'),"btnLinkFunction":_vm.btnLinkFunction}})
}
var staticRenderFns = []

export { render, staticRenderFns }